<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.3335 12.6667L2.66683 8.00002L7.3335 3.33335M13.3335 8.00002L2.66683 8.00002L13.3335 8.00002Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
